<script lang="ts">
    import Divider from '$lib/components/_DisplayComponents/Divider.svelte';
    import { getColor } from '$lib/helper';

    // Types
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { DividerContent } from '$lib/types/Components/Divider/DividerContent';

    export let theme: Theme;
    export let content: DividerContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
</script>

<svelte:component
    this={Divider}
    box={content.box}
    hidden={content.hidden}
    dashed={content.dashed}
    color={getColor(content.color, theme.fontColor)}
    {transitionDelay}
    {transitionEffect}
/>
